import React from 'react';
import axios from 'axios';
import Select from 'react-select';

import style from './Screenshot.module.css';

import {
	getSession,
} from 'Vulture/Session';

import {
	broncoURL,
} from 'Vulture/ENV';

import {
	SystemAssignmentConfirmationModal,
} from './SystemAssignmentModal';
import {
	selectComponents,
} from './utils/reactSelectUtils';

class SystemAssignmentView extends React.Component {
	constructor(props) {
		super(props);

		this.state = {
			accountsFD: {},

			fetchedAccounts: [],

			sourceAccount:                 null,
			sourceAccountOptions:          [],
			sourceAccountSelectorDisabled: true,

			sourceSystemGroup:                 null,
			sourceSystemGroupOptions:          [],
			sourceSystemGroupSelectorDisabled: true,

			targetAccount:                 null,
			targetAccountOptions:          [],
			targetAccountSelectorDisabled: true,
		};
	}

	clearState() {
		this.setState({
			accountsFD:      {},
			fetchedAccounts: [],

			sourceAccount:                 null,
			sourceAccountOptions:          [],
			sourceAccountSelectorDisabled: true,

			sourceSystemGroup:                 null,
			sourceSystemGroupOptions:          [],
			sourceSystemGroupSelectorDisabled: true,

			targetAccount:                 null,
			targetAccountOptions:          [],
			targetAccountSelectorDisabled: true,
		});
	}

	componentDidMount() {
		this.getAccountsData();
	}

	getImmediateChildrenSystemGroups(m1Key) {
		const {
			accountsFD,
		} = this.state;

		const childrenSystemGroups = Object.keys(accountsFD[m1Key])
			.filter((m2Key) => {
				return m2Key.startsWith('system_group.');
			});

		return childrenSystemGroups;
	}

	getAllChildrenSystemGroups(accountKey) {
		const {
			accountsFD,
		} = this.state;

		const processedSystemGroups = [];
		const systemGroups = [ ...this.getImmediateChildrenSystemGroups(accountKey), ];
		let lastSystemGroupsLength;

		while (processedSystemGroups.length !== lastSystemGroupsLength) {
			lastSystemGroupsLength = processedSystemGroups.length;
			const newSystemGroups = [];

			systemGroups
				.filter((systemGroupKey) => {
					return !processedSystemGroups.includes(systemGroupKey);
				})
				.forEach((systemGroupKey) => {
					newSystemGroups.push(...this.getImmediateChildrenSystemGroups(systemGroupKey));
					processedSystemGroups.push(systemGroupKey);
				});

			systemGroups.push(...newSystemGroups);
		}

		const targetSystemGroupOptions = Object.entries(accountsFD)
			.filter(([ key, ]) => {
				return systemGroups.includes(key);
			})
			.map(([ systemGroupUUID, systemGroupVal, ]) => {
				return {
					label: systemGroupVal.display_name,
					value: systemGroupUUID,
				};
			});

		return targetSystemGroupOptions;
	}

	async getAccountsData() {
		const {
			app,
		} = this.props;

		const {
			accountsFD,
		} = this.state;

		const session = getSession();
		const url = `${broncoURL}/account/list`;
		const body = {
			user: session.user,
		};

		app.setState({
			loading: true,
		});

		const res = await axios.post(url, body, {});
		if (res.status !== 200) {
			app.openModal({
				modalSize:  1,
				showModal:  true,
				modalProps: {
					title: 'Request failed',
					jsx:   (
						<SystemAssignmentConfirmationModal
							closeModal={app.closeModal.bind(app)}
							message={`Failed request to ${broncoURL}/account/list: ${res.statusText}`}
						/>
					),
				},
			});

			app.setState({
				loading: false,
			});

			return;
		}

		const prefixedData = {};
		for (const [uuid, val] of Object.entries(res.data)) {
			prefixedData[`account.${uuid}`] = val;
		}

		const newAccountsFD = {
			...accountsFD,
			...prefixedData,
		};

		const accountOptions = Object.entries(newAccountsFD)
			.filter(([ accountUUID, ]) => {
				return accountUUID.startsWith('account.');
			})
			.map(([ accountUUID, accountVal, ]) => {
				return {
					label: accountVal.display_name,
					value: accountUUID,
				};
			});

		this.setState({
			accountsFD: newAccountsFD,

			sourceAccountOptions: accountOptions,
			targetAccountOptions: accountOptions,

			sourceAccountSelectorDisabled: false,
			targetAccountSelectorDisabled: false,
		});

		app.setState({
			loading: false,
		});
	}

	async getSystemGroupsData(accountM1UUID) {
		const {
			app,
		} = this.props;

		const {
			accountsFD,
			fetchedAccounts,
		} = this.state;

		if (fetchedAccounts.includes(accountM1UUID)) {
			return accountsFD;
		}

		const session = getSession();
		const url = `${broncoURL}/system_assignment/account`;
		const body = {
			user:         session.user,
			account_uuid: accountM1UUID,
		};

		app.setState({
			loading: true,
		});

		const res = await axios.post(url, body, {});

		if (res.status !== 200) {
			app.openModal({
				modalSize:  1,
				showModal:  true,
				modalProps: {
					title: 'Request failed',
					jsx:   (
						<SystemAssignmentConfirmationModal
							closeModal={app.closeModal.bind(app)}
							message={`Failed request to ${broncoURL}/system_assignment/account: ${res.statusText}`}
						/>
					),
				},
			});

			app.setState({
				loading: false,
			});

			return;
		}

		const newAccountsFD = {
			...accountsFD,
			...res.data,
		};

		this.setState({
			accountsFD: newAccountsFD,

			sourceAccountSelectorDisabled: false,
			targetAccountSelectorDisabled: false,
			fetchedAccounts:               [ ...fetchedAccounts, accountM1UUID, ],
		});

		app.setState({
			loading: false,
		});

		return newAccountsFD;
	}

	async moveSystems() {
		const {
			app,
		} = this.props;

		const {
			sourceAccount,
			sourceSystemGroup,
			targetAccount,
		} = this.state;

		// Check if this is a no-op (same account)
		if (sourceAccount.value === targetAccount.value) {
			app.openModal({
				modalSize:  1,
				showModal:  true,
				modalProps: {
					title: 'No operation',
					jsx:   (
						<SystemAssignmentConfirmationModal
							closeModal={app.closeModal.bind(app)}
							message={'Source and target accounts are the same.'}
						/>
					),
				},
			});
			return;
		}

		// Call the new endpoint for system group reassignment
		app.setState({
			loading: true,
		});

		try {
			// Extract UUIDs from the M1 keys (format: "account.{uuid}" or "system_group.{uuid}")
			const sourceAccountUUID = sourceAccount.value.split('.')[1];
			const targetAccountUUID = targetAccount.value.split('.')[1];
			const systemGroupUUID = sourceSystemGroup.value.split('.')[1];

			const response = await axios.post(
				`${broncoURL}/system_groups/reassign_account`,
				{
					sourceAccountId: sourceAccountUUID,
					targetAccountId: targetAccountUUID,
					systemGroupId:   systemGroupUUID,
				},
				{
					headers: {
						'X-Auth-Session': getSession().session,
					},
				}
			);

			const {
				data,
			} = response;

			let successMessage = (
				<>
					<p>Successfully migrated system group to new account.</p>

					<div style={{
						marginTop:       '15px',
						marginBottom:    '15px',
						padding:         '15px',
						backgroundColor: '#f8f9fa',
						borderRadius:    '4px',
					}}>
						<div style={{
							display:      'flex',
							alignItems:   'center',
							marginBottom: '8px',
							color:        '#6c757d',
							fontSize:     '14px',
							fontWeight:   '500',
						}}>
							Systems migrated
						</div>
						<div style={{
							fontSize:   '32px',
							fontWeight: 'bold',
							color:      '#212529',
						}}>
							{data.systemsMigrated || 0}
						</div>
					</div>

					{data.s3CopyCommands && data.s3CopyCommands.length > 0 && (
						<div style={{
							marginTop: '15px',
						}}>
							<p><strong>S3 File Copy Commands:</strong></p>
							<p style={{
								fontSize:     '12px',
								color:        '#666',
								marginBottom: '10px',
							}}>
								Execute these commands to copy media files to the new account:
							</p>
							<pre style={{
								background:   '#f5f5f5',
								padding:      '10px',
								borderRadius: '4px',
								overflow:     'auto',
								maxHeight:    '300px',
								fontSize:     '11px',
								border:       '1px solid #ddd',
							}}>
								{data.s3CopyCommands.join('\n')}
							</pre>
						</div>
					)}
				</>
			);

			app.openModal({
				modalSize:  1,
				showModal:  true,
				modalProps: {
					title: 'System Group Reassignment Complete',
					jsx:   (
						<SystemAssignmentConfirmationModal
							closeModal={() => {
								app.closeModal();
								window.location.reload();
							}}
							message={successMessage}
						/>
					),
				},
			});
		} catch (error) {
			console.error('System group reassignment failed:', error);

			let errorTitle = 'Reassignment Failed';
			let errorMessage = 'An unexpected error occurred during system group reassignment. Please try again or contact support if the issue persists.';

			if (error.response && error.response.data) {
				const data = error.response.data;
				const errorCode = data.error;
				const message = data.message;

				switch (errorCode) {
				case 'permission_denied':
					errorTitle = 'Permission Denied';
					errorMessage = message || 'You do not have permission to perform this operation. Only internal administrators can reassign system groups between accounts.';
					break;
				case 'missing_fields':
					errorTitle = 'Invalid Request';
					errorMessage = 'The request is missing required information. Please refresh the page and try again.';
					break;
				case 'invalid_system_group_id':
					errorTitle = 'Invalid Selection';
					errorMessage = 'One or more of your selections is invalid. Please refresh the page and try again.';
					break;

				case 'source_account_not_found':
					errorTitle = 'Source Account Not Found';
					errorMessage = 'The selected source account could not be found. It may have been deleted.';
					break;
				case 'target_account_not_found':
					errorTitle = 'Target Account Not Found';
					errorMessage = 'The selected target account could not be found. It may have been deleted.';
					break;
				case 'system_group_not_found':
					errorTitle = 'System Group Not Found';
					errorMessage = 'The selected system group could not be found. It may have been deleted.';
					break;
				case 'ownership_mismatch':
					errorTitle = 'Ownership Mismatch';
					errorMessage = message || 'One or more system groups in the hierarchy do not belong to the source account. Please verify your selection.';
					if (data.systemGroupName) {
						errorMessage += `\n\nProblem detected with: ${data.systemGroupName}`;
					}
					break;
				case 'same_account':
					errorTitle = 'Same Account Selected';
					errorMessage = 'The source and target accounts must be different. Please select a different target account.';
					break;
				case 'component_group_relation_active':
					errorTitle = 'Active Component Group Relationships';
					errorMessage = 'The system group has active component group relationships that must be removed before reassignment. Please remove these relationships and try again.';
					if (data.systemUUIDs && data.systemUUIDs.length > 0) {
						errorMessage += `\n\nAffected systems: ${data.systemUUIDs.length}`;
					}
					break;
				case 'listing_config_shared':
					errorTitle = 'Shared Listing Configurations';
					errorMessage = 'The system group uses listing configurations that are shared with other system groups in the source account. These must be unshared before reassignment.';
					if (data.sharedListingConfigCount) {
						errorMessage += `\n\nShared configurations: ${data.sharedListingConfigCount}`;
					}
					break;
				case 'component_shared': {
					errorTitle = 'Shared Components';
					errorMessage = 'Some content in this system group is also used by systems outside it, so moving it would break those systems. Move those systems together with this group, or remove the shared content first. (Plain slides shared through Pelican slideshows are copied for the moved systems automatically; anything listed below could not be copied.)';
					const conflicts = Array.isArray(data.conflicts) ? data.conflicts : [];
					const unique = (values) => [ ...new Set(values.filter(Boolean)), ];
					const listUpTo = (values, max) => {
						const shown = values.slice(0, max).join(', ');
						return values.length > max ? `${shown}, and ${values.length - max} more` : shown;
					};
					const groupNames = unique(conflicts.map((c) => c.systemGroupName));
					const systemNames = unique(conflicts.map((c) => c.systemName));
					const contentNames = unique(conflicts.map((c) => c.componentName));
					if (groupNames.length > 0) {
						errorMessage += `\n\nProperties: ${listUpTo(groupNames, 10)}`;
					}
					if (systemNames.length > 0) {
						errorMessage += `\n\nSystems: ${listUpTo(systemNames, 10)}`;
					}
					if (contentNames.length > 0) {
						errorMessage += `\n\nShared content: ${listUpTo(contentNames, 10)}`;
					} else if (data.conflictingSystems && data.conflictingSystems.length > 0) {
						errorMessage += `\n\nOther systems using it: ${data.conflictingSystems.length}`;
					}
					break;
				}
				case 'database_error':
					errorTitle = 'Database Error';
					errorMessage = message || 'A database error occurred while processing your request. Please try again later.';
					break;
				case 'transaction_failed':
					errorTitle = 'Transaction Failed';
					errorMessage = 'The reassignment transaction could not be completed. No changes were made. Please try again.';
					break;
				default:
					// If we have a message from the server, use it
					if (message) {
						errorMessage = message;
					}
					// If there's an error code we don't recognize, show it
					if (errorCode && errorCode !== 'error') {
						errorMessage += `\n\nError code: ${errorCode}`;
					}
					break;
				}
			} else if (error.response && error.response.status === 403) {
				errorTitle = 'Permission Denied';
				errorMessage = 'You do not have permission to perform this operation. Only internal administrators can reassign system groups between accounts.';
			} else if (error.response && error.response.status === 404) {
				errorTitle = 'Not Found';
				errorMessage = 'The requested resource could not be found. Please refresh the page and try again.';
			} else if (error.response && error.response.status >= 500) {
				errorTitle = 'Server Error';
				errorMessage = 'A server error occurred. Please try again later or contact support if the issue persists.';
			} else if (error.message) {
				errorMessage = `An error occurred: ${error.message}`;
			}

			app.openModal({
				modalSize:  1,
				showModal:  true,
				modalProps: {
					title: errorTitle,
					jsx:   (
						<SystemAssignmentConfirmationModal
							closeModal={app.closeModal.bind(app)}
							message={errorMessage}
						/>
					),
				},
			});
		} finally {
			app.setState({
				loading: false,
			});
		}
	}

	render() {
		const {
			sourceAccount,
			sourceSystemGroup,
			targetAccount,
			sourceAccountSelectorDisabled,
			sourceSystemGroupSelectorDisabled,
			targetAccountSelectorDisabled,
			sourceAccountOptions,
			sourceSystemGroupOptions,
			targetAccountOptions,
		} = this.state;

		return (
			<div className={`systems-page fade-in`}>
				<div className={style.pageHeader}>
					<h2 data-test-id="systemAssignmentPageTitle">System Group Reassignment</h2>
					<div className={style.headerDetails}>Move an entire system group (and all its systems) from one account to another.</div  >
				</div>
				<div className={style.assignmentContent}>
					<div className={style.inputsWrapper}>
						<div className={style.label}>
							<label>Source Account:</label>
						</div>
						<Select
							options={sourceAccountOptions}
							components={selectComponents}
							dropdownIndicatorTestId="indicator-sourceAccount"
							optionTestIdPrefix="option"
							onChange={(e) => {
								const accountM1 = e.value;
								const accountM1UUID = accountM1.split('.')[1];

								this.getSystemGroupsData(accountM1UUID)
									.then(() => {
										const _sourceSystemGroupOptions = this.getAllChildrenSystemGroups(accountM1);

										this.setState({
											sourceAccount:                     e,
											sourceSystemGroup:                 null,
											sourceSystemGroupSelectorDisabled: false,
											sourceSystemGroupOptions:          _sourceSystemGroupOptions,
											sourceSystems:                     null,
											sourceSystemSelectorDisabled:      true,
										});
									});
							}}
							isDisabled={sourceAccountSelectorDisabled}
							value={sourceAccount}
						/>
						<div className={style.label}>
							<label>Source System Group:</label>
						</div>
						<Select
							options={sourceSystemGroupOptions}
							components={selectComponents}
							dropdownIndicatorTestId="indicator-sourceSystemGroup"
							optionTestIdPrefix="option"
							onChange={(e) => {
								this.setState({
									sourceSystemGroup: e,
								});
							}}
							isDisabled={sourceSystemGroupSelectorDisabled}
							value={sourceSystemGroup}
						/>
						<div className={style.pageHeader}>
							<h2></h2>
							<div className={style.headerDetails}></div  >
						</div>
					</div>
					<div className={style.inputsWrapper}>
						<div className={style.label}>
							<label>Target Account:</label>
						</div>
						<Select
							options={targetAccountOptions}
							components={selectComponents}
							dropdownIndicatorTestId="indicator-targetAccount"
							optionTestIdPrefix="option"
							onChange={(e) => {
								this.setState({
									targetAccount: e,
								});
							}}
							isDisabled={targetAccountSelectorDisabled}
							value={targetAccount}
						/>
						<div className={style.moveBtnContainer}>
							<br></br>
							<button
								className='button'
								data-test-id="moveSystemGroupButton"
								onClick={this.moveSystems.bind(this)}
								disabled={!(sourceAccount && sourceSystemGroup && targetAccount)}
							>
								Move System Group
							</button>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default SystemAssignmentView;